"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _genericInput = _interopRequireDefault(require("./generic-input"));

var validateCodeMinLength = function validateCodeMinLength(value) {
  if (value.length < 6) {
    return {
      valid: false,
      errorMessage: "Verification code must be at least 6 digits long"
    };
  }

  return {
    valid: true,
    errorMessage: ""
  };
};

var VerificationCodeInput = function VerificationCodeInput(props) {
  return _react["default"].createElement(_genericInput["default"], props);
};

VerificationCodeInput.defaultProps = {
  labelText: "Enter your code",
  inputId: "verification_code",
  inputName: "verification_code",
  inputType: "number",
  validator: validateCodeMinLength
};
var _default = VerificationCodeInput;
exports["default"] = _default;